<template>
  <PersonnelUserInfo/>
</template>
<script>
import PersonnelUserInfo from 'place/personnelverify/personnelUserInfo.vue'
export default {
    components:{
      PersonnelUserInfo
    }
}
</script>